import OrderLines from '@/classes/procedure_executions/OrderLines'
import { get as _get } from 'lodash'

export default class Order {
  constructor (order) {
    this.order_lines = new OrderLines(_get(order, 'order_lines', order))
  }
}
